/* global Swiper */
const sliders = {
	el: {
		sliderContainer: document.querySelectorAll('.js-slider')
	},

	fxInitSlider(el) {
		const sliderCentered = el.dataset.sliderCentered && JSON.parse(el.dataset.sliderCentered),
			sliderDelay = el.dataset.sliderDelay && JSON.parse(el.dataset.sliderDelay),
			sliderLoop = el.dataset.sliderLoop && JSON.parse(el.dataset.sliderLoop),
			sliderAutoPlay = el.dataset.sliderAutoplay && JSON.parse(el.dataset.sliderAutoplay),
			sliderSizeWide = el.dataset.sliderWide && JSON.parse(el.dataset.sliderWide),
			sliderSizeLarge = el.dataset.sliderLarge && JSON.parse(el.dataset.sliderLarge),
			sliderSizeMedium = el.dataset.sliderMedium && JSON.parse(el.dataset.sliderMedium),
			sliderSizeSmall = el.dataset.sliderSmall && JSON.parse(el.dataset.sliderSmall),
			sliderPaginationType = el.dataset.sliderPaginationType && el.dataset.sliderPaginationType,
			sliderSpaceBetween = el.dataset.sliderSpaceBetween && JSON.parse(el.dataset.sliderSpaceBetween),
			sliderOnInteraction = el.dataset.sliderOnInteraction && JSON.parse(el.dataset.sliderOnInteraction),
			sliderNoSwipe = el.dataset.sliderNoSwipe && JSON.parse(el.dataset.sliderNoSwipe),
			sliderFreeMode = el.dataset.sliderFreemode && JSON.parse(el.dataset.sliderFreemode),
			sliderFreeModeSticky = el.dataset.sliderFreemodeSticky && JSON.parse(el.dataset.sliderFreemodeSticky),
			sliderKeyboard = el.dataset.sliderKeyboard && JSON.parse(el.dataset.sliderKeyboard),
			sliderMouseWheel = el.dataset.sliderMousewheel && JSON.parse(el.dataset.sliderMousewheel),
			sliderScroll = el.dataset.sliderScroll && JSON.parse(el.dataset.sliderScroll),
			sliderSpeed = el.dataset.sliderSpeed && JSON.parse(el.dataset.sliderSpeed),
			slidesPerGroup = el.dataset.sliderGroup && JSON.parse(el.dataset.sliderGroup),
			slidesPerColumn = el.dataset.sliderColumn && JSON.parse(el.dataset.sliderColumn)

		const swiperOptions = {
			slidesPerView: sliderSizeSmall ? sliderSizeSmall : 1,
			centeredSlides: sliderCentered ? sliderCentered : false,
			centeredSlidesBounds: sliderCentered ? true : false,
			loop: sliderLoop ? sliderLoop : false,
			spaceBetween: sliderSpaceBetween ? sliderSpaceBetween : 0,
			noSwiping: sliderNoSwipe ? sliderNoSwipe : false,
			speed: sliderSpeed ? sliderSpeed : 300,
			freeMode: sliderFreeMode ? sliderFreeMode : false,
			freeModeSticky: sliderFreeMode && sliderFreeModeSticky ? sliderFreeModeSticky : false,
			slideToClickedSlide: sliderFreeMode ? true : false,
			slidesPerGroup: slidesPerGroup ? slidesPerGroup : 1,
			slidesPerColumn: slidesPerColumn ? slidesPerColumn : 1,
			watchOverflow: true,
			mousewheel: sliderFreeMode ? {
				releaseOnEdges: true
			} : sliderMouseWheel ? sliderMouseWheel : false,

			keyboard: {
				enabled: sliderKeyboard ? sliderKeyboard : false
			},

			navigation: {
				nextEl: el.querySelector('.swiper-button-next'),
				prevEl: el.querySelector('.swiper-button-prev')
			},

			pagination: {
				el: el.querySelector('.swiper-pagination'),
				clickable: sliderPaginationType ? false : true,
				type: sliderPaginationType ? sliderPaginationType : 'bullets' //"bullets", "fraction", "progressbar" or "custom"  (default:"bullets")
			},

			scrollbar: {
				el: sliderScroll ? sliderScroll : null,
				hide: sliderScroll && true
			},

			autoplay: sliderAutoPlay === true ? {
				delay: sliderDelay ? sliderDelay : 5000,
				disableOnInteraction: sliderOnInteraction ? sliderOnInteraction : false
			} : false,

			breakpoints: {
				768: { //tablet up
					slidesPerView: sliderSizeMedium ? sliderSizeMedium : sliderSizeSmall ? sliderSizeSmall : 1
				},
				1024: { //small desktop up
					slidesPerView: sliderSizeLarge ? sliderSizeLarge : sliderSizeMedium ? sliderSizeMedium : sliderSizeSmall ? sliderSizeSmall : 1
				},
				1440: { // desktop up
					slidesPerView: sliderSizeWide ? sliderSizeWide : sliderSizeLarge ? sliderSizeLarge : sliderSizeMedium ? sliderSizeMedium : sliderSizeSmall ? sliderSizeSmall : 1
				}
			},

			on: {
				init: () => setTimeout(() => window.dispatchEvent(new Event('resize')), 100)
			}
		}

		new Swiper(el, swiperOptions)
	},

	init() {
		this.el.sliderContainer.forEach(el => this.fxInitSlider(el))
	}
}
sliders.init()